'use client';

import ImageCarousel from '../common/ImageCarousel';

type ImageSliderProps = {
  images?: string[]; // make optional just in case
  heightClass?: string; // allow overriding height
};

const ImageSlider: React.FC<ImageSliderProps> = ({
  images = [],
  heightClass = 'h-[25rem]',
}) => {
  const imageCount = images.length;
  const slidesToShow = Math.min(imageCount, 3);

  return (
    <div className='w-full mt-2 mx-auto relative md:px-0 px-0'>
      <ImageCarousel
        images={images}
        alt='Activity image'
        className={`w-full ${heightClass} overflow-hidden rounded-lg`}
        imageClassName={`rounded-lg object-cover w-full ${heightClass}`}
        showNavigation={imageCount > 1}
        showPagination={false}
        autoplay={true}
        loop={imageCount > 1}
        navigationId='main-slider'
        buttonSize='lg'
        slidesPerView={slidesToShow}
        spaceBetween={10}
        breakpoints={{
          0: { slidesPerView: 1, spaceBetween: 0 },
          640: { slidesPerView: 1, spaceBetween: 0 },
          768: { slidesPerView: Math.min(imageCount, 2), spaceBetween: 10 },
          1024: { slidesPerView: slidesToShow, spaceBetween: 10 },
        }}
        enableFullscreen={true}
        fullscreenTitle='Activity Images'
      />
      {/* Custom Pagination (mobile only) */}
      {imageCount > 1 && (
        <div className='custom-pagination flex justify-center -mt-8 md:hidden relative z-50' />
      )}
    </div>
  );
};

export default ImageSlider;
